import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

export const appInsights = connectionString
  ? new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: true,
      },
    })
  : null;

if (appInsights) {
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}
